var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPharmacy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "800px",
    height: "800px",
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#ff005c;}"))), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Bandage"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    height: 7.07,
    transform: "translate(-9.32 22.5) rotate(-45)",
    width: 11.31,
    x: 16.84,
    y: 18.96
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    height: 7.07,
    transform: "translate(-3.94 9.5) rotate(-45)",
    width: 11.31,
    x: 3.84,
    y: 5.96
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.71,10.5,21.5,2.29H20.08L16,6.37,11.92,2.29H10.5L2.29,10.5v1.42L6.37,16,2.29,20.08V21.5l8.21,8.21h1.42L16,25.63l4.08,4.08H21.5l8.21-8.21V20.08L25.63,16l4.08-4.08Zm-25.3.71,6.8-6.8,3.38,3.38-6.8,6.8Zm23.18,9.58-6.8,6.8-3.38-3.38,6.8-6.8Zm-4.09-5.5L15.29,23.5l-4.08,4.09-6.8-6.8L8.5,16.71,16.71,8.5l4.08-4.09,6.8,6.8Z"
  }), /*#__PURE__*/React.createElement("rect", {
    height: 2,
    transform: "translate(-3.51 15.54) rotate(-45)",
    width: 2.83,
    x: 15.59,
    y: 11
  }), /*#__PURE__*/React.createElement("rect", {
    height: 2,
    transform: "translate(-4.75 18.54) rotate(-45)",
    width: 2.83,
    x: 18.59,
    y: 14
  }), /*#__PURE__*/React.createElement("rect", {
    height: 2,
    transform: "translate(-8.51 13.46) rotate(-45)",
    width: 2.83,
    x: 10.59,
    y: 16
  }), /*#__PURE__*/React.createElement("rect", {
    height: 2,
    transform: "translate(-9.75 16.46) rotate(-45)",
    width: 2.83,
    x: 13.59,
    y: 19
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPharmacy);
export default __webpack_public_path__ + "static/media/pharmacy.a04ec9c08b0db42cf45ebb6703f537e8.svg";
export { ForwardRef as ReactComponent };